module.exports = __webpack_public_path__ + "media/images/documentIcon-63783e9f.svg";